import { useTranslation } from "react-i18next";
import "../styles/header.css";
import { useState } from "react";

function Header() {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <header className={`header ${i18n.language === "ar" ? "rtl" : "ltr"}`}>
      {/* Logo and Company Name */}
      <div className="header-brand">
        <img src="/logo.png" alt="Company Logo" className="header-logo" />
        <h1 className="company-name">{t("header.companyName")}</h1>
      </div>

      {/* Navigation */}
      <nav className={`header-nav ${menuOpen ? "active" : ""}`}>
        <a href="#projects">{t("header.projects")}</a>
        <a href="#contact">{t("header.contact")}</a>
      </nav>

      {/* Language Switcher */}
      <div className="language-switcher">
        <button onClick={() => changeLanguage("en")}>EN</button>
        <button onClick={() => changeLanguage("fr")}>FR</button>
        <button onClick={() => changeLanguage("ar")}>AR</button>
      </div>

      {/* Mobile Menu Button */}
      <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </button>

      {/* Mobile Menu Backdrop */}
      {menuOpen && (
        <div className="menu-backdrop" onClick={() => setMenuOpen(false)}></div>
      )}
    </header>
  );
}

export default Header;
